import React from 'react'
import { InputBaseProps, InputBase } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface StyleProps {
    fontColor?: string
    color?: string
    tooltipStyles: {}
}

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(2),
    },

    '&': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.6rem',
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '0.1rem solid #ebebed',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        color: theme.palette.common.black,
        margin: 'auto',
        borderRadius: '0.4rem',

        '&:hover': {
            borderColor: `${theme.palette.primary.main} !important`,
        },
        '&:focus': {
            borderColor: theme.palette.primary.main,
            boxShadow: '0 0.2rem 0.4rem 0 rgba(48, 127, 193, 0.15)',
            backgroundColor: theme.palette.common.white,
        },
        '&:focus-visible': {
            borderColor: `${theme.palette.primary.main} !important`,
            boxShadow: '0 0.2rem 0.4rem 0 rgba(48, 127, 193, 0.15)',
            backgroundColor: theme.palette.common.white,
            outline: 'none',
        },
        '&.Mui-focused': {
            borderColor: `${theme.palette.primary.main} !important`,
            boxShadow: '0 0.2rem 0.4rem 0 rgba(48, 127, 193, 0.15)',
            backgroundColor: theme.palette.common.white,
        },
    },

    '& .MuiInputBase-input': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.6rem',
        padding: '1.1rem 1rem',
        borderRadius: '0.4rem',

        '&:focus': {
            boxShadow: '0 0.2rem 0.4rem 0 rgba(48, 127, 193, 0.15)',
            outline: '1px solid #0057A0',
            outlineOffset: '1px',
        },
        '&:focus-visible': {
            boxShadow: '0 0.2rem 0.4rem 0 rgba(48, 127, 193, 0.15)',
            outline: 'none',
        },
    },
}))

export interface InputProps extends InputBaseProps {}

export const Input: React.FC<InputProps> = ({ placeholder, ...rest }) => {
    return <StyledInputBase fullWidth {...rest} />
}
